import APITemplate from '@/api/APITemplate'

const url = '/restricted-area'

const template = APITemplate(url)
export default {
  ...template
}
